module.exports = __webpack_public_path__ + "static/img/310.40b3e93d.png";